import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDetentionTracking extends Layout {
    labelCharging: Label;
    labelChargingCount: Label;
    labelFreeTime: Label;
    labelFreeTimeCount: Label;
    labelOccurred: Label;
    labelOccurredCount: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    panelCharging: Panel;
    panelFreeTime: Panel;
    panelOccurred: Panel;
    panelTotal: Panel;
    sourceDetentionProfileSearch: DataSource;
}
